import React from "react";

import { FullPageNotionEmbed, Header } from "src/shared/components";

const WELCOME_BOOKLET_EMBED_URL =
  "https://hackthenorth.notion.site/ebd/3cab70e03de7803a95e3ec04a581c95f";

const WelcomeBooklet: React.FC = () => (
  <>
    <Header
      title="Welcome Booklet"
      subtitle="Your guide to Hack the North 2026"
    />
    <FullPageNotionEmbed
      url={WELCOME_BOOKLET_EMBED_URL}
      title="Hack the North 2026 Welcome Booklet"
      fallbackLinkLabel="Open the Welcome Booklet in Notion"
    />
  </>
);

export default WelcomeBooklet;
